/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import { __assign, __awaiter, __generator } from "tslib";
import { ValueObject } from './ddd-types/value-object';
import { camelKeys, snakeKeys } from '@tencent/ark-utils/lib/object';
import { Logger } from '@tencent/logger';
import { getMessageFromData, getRetCodeFromData } from './common/normalize';
import { isCgiDataAndRetCodePerfected } from './utils';
// request打印错误日志的全局Logger
var logger = new Logger('domain').use('console');
logger.level = 'OFF';
/**
 * request统一的try-catch装饰器
 */
export function exceptionHandler() {
    return function (target, name, descriptor) {
        var originalFn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var data, resData, error_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, originalFn.apply(this, args)];
                        case 1:
                            data = (_b.sent()).data;
                            resData = {
                                data: data,
                                retcode: getRetCodeFromData(data),
                                msg: getMessageFromData(data),
                                cgicode: (_a = data.cgicode) !== null && _a !== void 0 ? _a : 0,
                            };
                            // 把data里默认的retcode、msg、cgicode干掉
                            delete data.msg;
                            delete data.message;
                            delete data.retmsg;
                            delete data.retcode;
                            delete data.code;
                            delete data.cgicode;
                            delete data.ret;
                            return [2 /*return*/, {
                                    resData: resData,
                                }];
                        case 2:
                            error_1 = _b.sent();
                            // request本身出错，直接返回错误信息，并写错误日志
                            logger.error("".concat(target.constructor.name, "|").concat(name, "|").concat(error_1));
                            return [2 /*return*/, { error: error_1, resData: {} }];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
    };
}
/**
 * request统一的try-catch装饰器
 */
export function requestResponseHandler() {
    return function (target, name, descriptor) {
        var originalFn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var data, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, originalFn.apply(this, args)];
                        case 1:
                            data = (_a.sent()).data;
                            return [2 /*return*/, { data: data }];
                        case 2:
                            error_2 = _a.sent();
                            // request本身出错，直接返回错误信息，并写错误日志
                            logger.error("".concat(target.constructor.name, "|").concat(name, "|").concat(error_2));
                            return [2 /*return*/, { error: error_2, data: {} }];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
    };
}
/**
 * 提供把responseHeaders里的指定字段同data一起返回
 * @param key 对应的key
 */
export function parseHeaderKey2DataHandler(headerKey, resKey) {
    return function (target, name, descriptor) {
        logger.debug("praseHeaderKey2DataHandler|".concat(target.constructor.name, "|").concat(name, "|").concat(headerKey));
        var originalFn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var res, data, headers;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, originalFn.apply(this, args)];
                        case 1:
                            res = _a.sent();
                            data = res.data, headers = res.headers;
                            // request成功 且有对应key 才会处理
                            if (data && headers && headers[headerKey]) {
                                data[resKey] = headers[headerKey];
                            }
                            return [2 /*return*/, res];
                    }
                });
            });
        };
    };
}
/**
 * 根据 ddd-type 是 ValueObject 还是 Entity，创建并初始化对应实例对象
 * @param constructor   // ddd-types 数据的构造器
 * @param data          // 初始化数据
 * @returns
 */
function createInstanceWith(constructor, data) {
    // 值对象
    if (constructor.prototype instanceof ValueObject) {
        return Reflect.construct(constructor, [data]);
    }
    // 实体
    var entity = Reflect.construct(constructor, ['mainEntity']);
    return entity.initWithJsonObj(data);
}
/**
 * 领域服务发送事件装饰器
 * @param attribute           // 数据要解析到的字段名
 * @param eventName           // 要发出事件的事件名
 * @returns
 */
export function fireEvent(eventName, attribute) {
    return function (target, name, descriptor) {
        logger.debug("fireEvent|".concat(target.constructor.name, "|").concat(name));
        var originalFn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var res, result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, originalFn.apply(this, args)];
                        case 1:
                            res = _a.sent();
                            // 只有在返回正确数据时才会发出通知
                            if (res.resData && isCgiDataAndRetCodePerfected(res.resData)) {
                                result = {};
                                result[attribute] = this[attribute];
                                this[eventName].fire(result);
                            }
                            // 原样返回数据
                            return [2 /*return*/, res];
                    }
                });
            });
        };
    };
}
export function changeSuperVipData() {
    return function (target, name, descriptor) {
        logger.debug("changeSuperVipData|".concat(target.constructor.name, "|").concat(name));
        var originalFn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var res, vipInfo, resData;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, originalFn.apply(this, args)];
                        case 1:
                            res = _d.sent();
                            if (res.error) {
                                return [2 /*return*/, res];
                            }
                            vipInfo = (_c = (_b = (_a = res.resData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.vip_info) !== null && _c !== void 0 ? _c : {};
                            vipInfo.super_vip = vipInfo === null || vipInfo === void 0 ? void 0 : vipInfo.super;
                            resData = __assign({}, res.resData);
                            resData.data.vip_info = vipInfo;
                            return [2 /*return*/, {
                                    resData: resData,
                                }];
                    }
                });
            });
        };
    };
}
/**
 * ddd-types数据类型解析 装饰器
 * @param constructor         // ddd-types数据的构造器
 * @param attribute           // 数据要解析到的字段名
 * @returns
 */
export function parseObjectData(constructor, attribute) {
    return function (target, name, descriptor) {
        logger.debug("parseObjectData|".concat(target.constructor.name, "|").concat(name));
        var originalFn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var res, resData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, originalFn.apply(this, args)];
                        case 1:
                            res = _a.sent();
                            if (res.error) {
                                return [2 /*return*/, res];
                            }
                            // 数据正常，aggregateVersion自增
                            this.aggregateVersion = this.aggregateVersion + 1;
                            // 正常解析数据
                            if (constructor.prototype instanceof ValueObject) {
                                this[attribute] = createInstanceWith(constructor, res.resData.data);
                            }
                            else {
                                this[attribute].initWithJsonObj(res.resData.data);
                            }
                            resData = __assign(__assign({}, res.resData), { data: this[attribute] });
                            return [2 /*return*/, {
                                    resData: resData,
                                }];
                    }
                });
            });
        };
    };
}
/**
 * ddd-types数据类型解析到数组 装饰器。  目前先不考虑加载更多的情况，如果有场景再扩展
 * @param constructor         // ddd-types数据的构造器
 * @param attribute           // 数据要解析到的数组名
 * @param arrayAttribute      // 被解析的的数组名
 * @returns
 */
export function parseArrayData(constructor, attribute, arrayAttribute) {
    return function (target, name, descriptor) {
        logger.debug("parseArrayData|".concat(target.constructor.name, "|").concat(name));
        var originalFn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var res, array, resData;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, originalFn.apply(this, args)];
                        case 1:
                            res = _a.sent();
                            if (res.error) {
                                return [2 /*return*/, res];
                            }
                            // 数据正常，aggregateVersion自增
                            this.aggregateVersion = this.aggregateVersion + 1;
                            array = res.resData.data[arrayAttribute] || [];
                            // 这里数组成员只追加数据，清理数组成员由API自己决定
                            array.forEach(function (element) {
                                _this[attribute].push(createInstanceWith(constructor, element));
                            });
                            resData = __assign(__assign({}, res.resData), { data: this[attribute] });
                            return [2 /*return*/, {
                                    resData: resData,
                                }];
                    }
                });
            });
        };
    };
}
/**
 * CGI二级数据（返回的object内嵌套的字段）到数组 装饰器。
 * @param constructor ddd-types数据的构造器
 * @param arrayName 数据要解析到的数组名
 * @param objectAttribute 数据要解析到的一级object名
 * @param arrayAttribute 数据要解析到的二级数组名，即CGI回包数据第一层object内部包裹的array
 * @returns
 */
export function parseArrayDataInObject(constructor, arrayName, objectAttribute, arrayAttribute) {
    return function (target, name, descriptor) {
        logger.debug("parseArrayDataInObject|".concat(target.constructor.name, "|").concat(name));
        var originalFn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var res, array, resData;
                var _this = this;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, originalFn.apply(this, args)];
                        case 1:
                            res = _b.sent();
                            if (res.error) {
                                return [2 /*return*/, res];
                            }
                            // 数据正常，aggregateVersion自增
                            this.aggregateVersion = this.aggregateVersion + 1;
                            array = ((_a = res.resData.data[objectAttribute]) === null || _a === void 0 ? void 0 : _a[arrayAttribute]) || [];
                            // 这里数组成员只追加数据，清理数组成员由API自己决定
                            array === null || array === void 0 ? void 0 : array.forEach(function (element) {
                                _this[arrayName].push(createInstanceWith(constructor, element));
                            });
                            resData = __assign(__assign({}, res.resData), { data: this[arrayName] });
                            return [2 /*return*/, {
                                    resData: resData,
                                }];
                    }
                });
            });
        };
    };
}
/**
 * 处理 GET 请求
 * 统一把 resData underScoreCase 命名转为 camelCase
 */
export function dataFieldNamingHandler() {
    return function (target, name, descriptor) {
        logger.debug("dataFieldNamingHandler|".concat(target.constructor.name, "|").concat(name));
        var originalFn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var res;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, originalFn.apply(this, args)];
                        case 1:
                            res = _b.sent();
                            if ((_a = res.resData) === null || _a === void 0 ? void 0 : _a.data) {
                                res.resData.data = camelKeys(res.resData.data);
                            }
                            return [2 /*return*/, res];
                    }
                });
            });
        };
    };
}
/**
 * 处理 POST 请求
 * 统一把请求发送参数 camelCase 命名转为 underScoreCase
 */
export function paramsFieldNamingHandler() {
    return function (target, name, descriptor) {
        logger.debug("paramsFieldNamingHandler|".concat(target.constructor.name, "|").concat(name));
        var originalFn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var newArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!args.length) return [3 /*break*/, 2];
                            return [4 /*yield*/, originalFn.apply(this, [])];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2:
                            newArgs = [snakeKeys(args[0])];
                            return [4 /*yield*/, originalFn.apply(this, newArgs)];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
    };
}
/**
* 统一把 respone 里的 body 字段给做脱壳处理
*/
export function parseResBody() {
    return function (target, name, descriptor) {
        logger.debug("parseResBody|".concat(target.constructor.name, "|").concat(name));
        var originalFn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var res, resData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, originalFn.apply(this, args)];
                        case 1:
                            res = _a.sent();
                            if (res.error) {
                                return [2 /*return*/, res];
                            }
                            resData = __assign(__assign({}, res.resData), { data: __assign({}, res.resData.data.body) });
                            return [2 /*return*/, { resData: resData }];
                    }
                });
            });
        };
    };
}
/**
* 设置数据处理方法装饰器
*/
export function setDataHandleFunctionName(functionName) {
    return function (target, name, descriptor) {
        logger.debug("parseResBody|".concat(target.constructor.name, "|").concat(name));
        var originalFn = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, originalFn.apply(this, args)];
                        case 1:
                            res = _a.sent();
                            if (res.error) {
                                return [2 /*return*/, res];
                            }
                            this[functionName](args);
                            return [2 /*return*/, res];
                    }
                });
            });
        };
    };
}
/**
 * 同步 tryCatch 处理函数
 * @param fallback 抛出错误时的默认返回值，可不传
 */
export function tryCatchHandler(fallback) {
    return function (target, name, descriptor) {
        logger.debug("parseResBody|".concat(target.constructor.name, "|").concat(name));
        var originalMethod = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var result;
            try {
                result = originalMethod.apply(this, args);
            }
            catch (e) {
                logger.error("tryCatchHandler caught error from ".concat(target.constructor.name, "|").concat(name, ". Error detail: ").concat(e));
                result = fallback;
            }
            return result || undefined;
        };
        return descriptor;
    };
}
/**
 * “方法未实现” 的装饰器
 * 将会抛出错误
 */
export function notImplementedErrorTriggerer() {
    return function (target, propertyKey, descriptor) {
        logger.debug("not implemented error|".concat(target, "|").concat(propertyKey, "|").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.value));
        descriptor.value = function () {
            throw new Error('Method not implemented');
        };
        return descriptor;
    };
}
